module.exports = __webpack_public_path__ + "img/MTABAPPADBP.1b50667a.jpg";